<template>
  <div class="card">
    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('propertySpecification.list') }}</h3>
        </div>
        <div class="card-toolbar">
          <Button v-if="$can(abilities.CREATE_CATEGORIES)" btn-class="btn-sm" type="new" btn-text="propertySpecification.create" @click="openCreationModal"/>
        </div>
      </div>

      <div class="card-body" >
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="property_specification_datatable" style="margin-top: 13px !important; cursor:pointer">
          <thead>
          <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
            <th class="min-w-50px">{{ $t('propertySpecification.name')}}</th>
            <th class="w-100px">{{ $t('action') }}</th>
          </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>

  <PropertySpecificationFormModal id="create-property-specification-modal" @callback="reloadDatatable"/>
  <PropertySpecificationFormModal id="edit-property-specification-modal" :form="formUpdateData" @callback="reloadDatatable" :edit="true"/>
</template>

<script setup>

import {nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import PropertySpecificationFormModal from "@/Modules/Projects/components/Modals/PropertySpecificationFormModal.vue";

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  name: '',
})



watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#property_specification_datatable").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/property/characteristic/dataTable",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "name" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span >' + t + "</span>";

        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_CATEGORIES)){
            render += '<a data-id="' + e.id + '" data-name="' + e.name + '" href="javascript:;" class="btn btn-sm btn-clean btn-icon edit_btn" title="' + i18n.global.t('button.edit') + '"><i data-id="' + e.id + '" data-name="' + e.name + '" class="fas fa-edit fs-2" style="color: ' + Theme.gray + '"></i></a>';
          }
          if(can(abilities.DELETE_CATEGORIES)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#property_specification_datatable .edit_btn", (e) => {
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.name = e.target.getAttribute('data-name')
    $('#edit-property-specification-modal').modal('toggle')
  });

  $(document).on("click", "#property_specification_datatable .delete_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    deletePropertySpecification(id)
  });
}

function reloadDatatable() {
  if (table.value) {
    table.value.ajax.reload();
  }
}

function openCreationModal() {
  $('#create-property-specification-modal').modal('toggle')
}

function deletePropertySpecification(id) {
  showSwal(
      '',
      i18n.global.t('swal.property_delete_specification')
  ).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('propertySpecifications/deleteProjectCategory', id)
        table.value.ajax.reload()
        window.toastr['success'](i18n.global.t("notification.property_specification_deleted"))
      }catch (e) {
      }
    }
  })
}

onMounted(() => {
  fetchDatas()
})
</script>
